<template>
  <v-app>
    <v-container fill-height fluid v-if="$store.getters.loading" justify-center align-center >
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
    </v-container>
    <inactive-layout v-else-if="$store.getters.user.loggedIn && $store.getters.user.data && !$store.getters.user.data.active" />
    <app-layout v-else-if="$store.getters.user.loggedIn" />
    <login-layout v-else />
  </v-app>
</template>

<script>

import * as firebase from "firebase"
import AppLayout from './layouts/AppLayout'
import LoginLayout from './layouts/LoginLayout'
import InactiveLayout from './layouts/InactiveLayout'

import { getLastPayment } from '@/store/module/billing'
import { getFavorites } from '@/store/module/favorite'

export default {
  name: "App",

  components: {
    'app-layout': AppLayout,
    'login-layout': LoginLayout,
    'inactive-layout': InactiveLayout
  },

  created: function () {
    this.validateSession()
  },

  data: () => ({
    //
  }),
  methods: {
    validateSession() {
      firebase.auth().onAuthStateChanged(user => {
        this.$store.dispatch('fetchUser', user).then(user_data => {
          if (this.$store.getters.user.loggedIn) {
            this.validateActiveUser(user_data)
          } else {
            if (this.$router.currentRoute.name !== 'Login') {
              this.$router.push({ name: 'Login' });
            }
          }
          // Get Favorites
          if (user) {
            getFavorites(user.uid)
            .then(favorites => {
              this.$store.dispatch('setFavorites', favorites)
            })
          }
        })
      })
    },
    validateActiveUser(user) {
      if (!user.active) {
        this.$router.push({ name: 'Inactive' })
        return
      } else if (user.premium || user.admin) {
        if (this.$router.currentRoute.name === 'Login') {
          this.$router.push({ name: 'Dashboard' })
        }
        return
      }
      // let valid = false
      // Billing
      getLastPayment()
      .then(payment => {
        let user_data = this.$store.getters.user.data
        // console.log('LAST PAYMENT', payment);
        user_data.last_payment = this.getLastPayment(user_data, payment)
        user_data.next_payment = this.getNextPayment(user_data, payment)
        // console.log('LAST PAYMENT', user_data.last_payment)
        // console.log('NEXT PAYMENT', user_data.next_payment)
        // Covered
        user_data.covered = this.isCoveredPayment(user_data)
        this.$store.dispatch('setUser', user_data)
        // Action if not is Covered
        if (!user_data.covered) {
          this.$store.dispatch('setUser', user_data)
          if (this.$router.currentRoute.name !== 'Billing') {
            this.$router.push({ name: 'Billing' })
          }
        } else if (this.$router.currentRoute.name === 'Login') {
          this.$router.push({ name: 'Dashboard' })
        }
      })
      .catch(error => {
        console.error('ERROR', error.message)
      })
    },
    getNextPayment(user_data, payment) {
      if (!payment) {
        let last_payment = new Date(user_data.last_payment)
        return new Date(last_payment.setMonth(last_payment.getMonth() + user_data.plan.cycle))
      }
      return new Date(payment.payment.coverage_date.seconds * 1000)
    },
    getLastPayment(user_data, payment) {
      if (!payment) {
        return new Date(user_data.affiliation.date.seconds * 1000)
      }
      return new Date(payment.payment.created_at.seconds * 1000)
    },
    isCoveredPayment(user_data) {
      let today = new Date()
      return today <= user_data.next_payment
    }
  }
}

</script>
